export const META_PIXEL_SCRIPT_URL =
  'https://connect.facebook.net/en_US/fbevents.js';

export const LINKEDIN_INSIGHT_SCRIPT_URL =
  'https://snap.licdn.com/li.lms-analytics/insight.min.js';

export const META_PIXEL_SCRIPT_ID = 'paid-social-meta-pixel';

export const LINKEDIN_INSIGHT_SCRIPT_ID = 'paid-social-linkedin-insight';

const GOOGLE_TAG_HOST = ['google', 'tagmanager.com'].join('');

export const GOOGLE_ADS_GTAG_SCRIPT_URL = `https://www.${GOOGLE_TAG_HOST}/gtag/js`;

export const GOOGLE_ADS_GTAG_SCRIPT_ID = 'paid-social-google-ads-gtag';

export const GROAS_CONTENT_SCRIPT_URL = 'https://app.groas.ai/content.js';

export const GROAS_CONTENT_SCRIPT_ID = 'paid-social-groas-content';

export const GROAS_CONTENT_PARAM = 'groas';

/**
 * Builds the `gtag.js` source for a conversion ID, matching Google's canonical
 * loader. Callers must validate the id before passing it in.
 *
 * @param {string} conversionId - Google Ads conversion ID from tenant-config.
 * @returns {string} Absolute `gtag.js` URL carrying the `id` parameter.
 */
export const buildGoogleAdsGtagScriptUrl = (conversionId: string): string => {
  return `${GOOGLE_ADS_GTAG_SCRIPT_URL}?id=${encodeURIComponent(conversionId)}`;
};

/**
 * OneTrust consent category ids. `ADVERTISING` is the category that gates
 * paid-social tags; the others are non-marketing categories a visitor may
 * have active alongside it, or instead of it.
 */
export const ONETRUST_GROUP = {
  NECESSARY: 'C0001',
  PERFORMANCE: 'C0002',
  FUNCTIONAL: 'C0003',
  ADVERTISING: 'C0004',
} as const;

export const ONETRUST_GROUPS_UPDATED_EVENT = 'OneTrustGroupsUpdated';

export const MARKETING_CONSENT_POLL_INTERVAL_MS = 100;

export const MARKETING_CONSENT_POLL_MAX_ATTEMPTS = 50;
